import { MarkAllNotificationsAsSeenClients, NotificationList, NotificationLoadMoreClients } from '@ms/yammer-graphql';
import { normalize } from 'normalizr';

import { Notification } from '../../state/types';

import { notificationPaginationsSchema } from './schemas/notifications';
import { NormalizedNotification, NormalizedNotificationEntities } from './types';

const filterUnsupportedNotifications = (notifications: Record<string, Notification>) => {
  const ids = Object.keys(notifications);

  return ids.reduce((filteredNotifications, currentId) => {
    const currentNotification = notifications[currentId];

    if (currentNotification.subtype == null || currentNotification.details == null) {
      return filteredNotifications;
    }

    return { ...filteredNotifications, [currentId]: currentNotification };
  }, {});
};

type NormalizeNotifications = (data: NotificationList) => NormalizedNotification;
const normalizeNotifications: NormalizeNotifications = (data) => {
  const { entities } = normalize<unknown, NormalizedNotificationEntities>(data, notificationPaginationsSchema);
  const pageInfo = data.pageInfo;
  const filteredNotifications = entities.notifications ? filterUnsupportedNotifications(entities.notifications) : {};

  return {
    entities: {
      ...entities,
      notifications: filteredNotifications,
    },
    pageInfo,
  };
};

type NormalizeNotificationsMarkSeen = (response: {
  readonly data: MarkAllNotificationsAsSeenClients;
}) => NormalizedNotification;
export const normalizeNotificationsMarkSeen: NormalizeNotificationsMarkSeen = (response) => {
  if (!response.data.markAllNotificationsAsSeen) {
    throw new Error('GraphQL response for marking notifications as seen is invalid!');
  }

  return normalizeNotifications(response.data.markAllNotificationsAsSeen.notifications);
};

type NormalizeNotificationsLoadMore = (response: {
  readonly data: NotificationLoadMoreClients;
}) => NormalizedNotification;
export const normalizeNotificationsLoadMore: NormalizeNotificationsLoadMore = (response) =>
  normalizeNotifications(response.data.viewer.notifications);
